/* eslint-disable */
import React, { useEffect, useState, forwardRef } from "react";
import { Helmet } from "react-helmet-async";
import classNames from "classnames";
import { headApi, localApi, credentials } from "utils/headApi";
import axios from "axios";
import { useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { makeStyles } from "@material-ui/core/styles";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import InshaSection from "views/InshaBanglesPage/Section/InshaSectionPro.js";
import InshaContact from "views/InshaBanglesPage/Section/InshaContact.js";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import { FiPhoneCall } from "react-icons/fi";

import presentationStyle from "assets/jss/material-kit-pro-react/views/presentationStyle.js";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";

const usePresentation = makeStyles(presentationStyle);
const useJavascript = makeStyles(javascriptStyles);
const useProduct = makeStyles(productStyle);

const Transition = forwardRef((props, ref) => (
  <Slide direction="down" ref={ref} {...props} />
));

export default function InshaPage() {
  const classes = usePresentation();
  const js = useJavascript();
  const prod = useProduct();
  const history = useHistory();

  const [mobile, setMobile] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [otpNumber, setOtpNumber] = useState("");
  const [otpNumberErr, setOtpNumberErr] = useState("");
  const [otpScreen, setOtpScreen] = useState(false);
  const [expectedOtp, setExpectedOtp] = useState("");
  const [loginModal, setLoginModal] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [userLocation, setUserLocation] = useState(null); // Store lat/lng

  const activeSession = sessionStorage.getItem("sessionData");

  const currentUrl = "https://inshabangles.com/";
  const seoTitle =
    "INSHA BANGLES | Imitation Jewellery Manufacturer & Exporter in India";
  const seoDescription =
    "INSHA BANGLES is a leading imitation jewellery manufacturer and exporter in India, offering stylish bangles, fashion jewellery, and wholesale designs for every occasion.";
  const seoKeywords =
    "INSHA BANGLES is a leading imitation jewellery manufacturer and exporter based in Malad, Mumbai, India, offering stylish bangles in sizes such as 1mm, 2mm, 3mm, 4mm, 5mm, 5/2.5mm, 6mm, 6/3mm, 7mm, 7/3.5mm, 8mm, 8/4mm, 9mm, 9/4.5mm, 10mm, 10/5mm, 11mm, 11/5.5mm, 12mm, 12/6mm, 13mm, 13/6.5mm, 14mm, 14/7mm, 15mm, 15/7.5mm, 16mm, 16/8mm, 17mm, 17/8.5mm, 18mm, 18/9mm, 19mm, 19/9.5mm, 20mm, 20/10mm, and 25mm, including gold-plated items such as micro gold plating, tri-colour plating, 7 semanario sets, 3-tone plating, rose gold plating, rhodium plating, and silver plating. We also offer gold-plated meenakari bangles, 2-tone bangles, new Mexican bangles, gold-plated/oro laminado products, hoop earrings (round, big, and modern styles), 3-tone plated bangles, 3-tone U earrings, women’s earrings, animal-designed bangles, kids’ baby 6mm tri-colour bangles, Seven Day (Semanario) bangle bracelets, Mexican 14K gold bangles, three-tone bangles, dual-tone dolphin bypass bangles, dual-tone bangles, fashion jewellery, and wholesale designs for every occasion.";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "INSHA BANGLES",
    url: "https://inshabangles.com",
    logo: "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png",
    sameAs: ["https://inshabangles.com"],
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    async function fetchInitialData() {
      try {
        const statesRes = await fetch(localApi + `/admin/groupState`, {
          headers: { Authorization: `Basic ${credentials}` },
        });
        const stateData = await statesRes.json();
        setStateList(stateData.map((f) => f.state));

        const companyRes = await axios.get(localApi + `/admin/allList`, {
          headers: { Authorization: `Basic ${credentials}` },
        });
        setCompanyList(companyRes.data.AdminList.map((f) => f.company));

        const categoryRes = await axios.get(localApi + `/category/allList`, {
          headers: { Authorization: `Basic ${credentials}` },
        });
        const cats = categoryRes.data.map((f) => f.title.toLowerCase());
        setCategoryList([...new Set(cats)]);

        const parentRes = await axios.get(localApi + `/parent/allList`, {
          headers: { Authorization: `Basic ${credentials}` },
        });
        const parents = parentRes.data.map((f) => f.title.toLowerCase());
        setParentList([...new Set(parents)]);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    }

    fetchInitialData();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          // silently save location, no alert or UI display
          // console.log("userLocation", userLocation);

          sessionStorage.setItem("userLocation", JSON.stringify(userLocation));
        },
        (error) => {
          console.error("Geolocation error:", error);
          // no alert to user, just log error silently
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    } else {
      console.error("Geolocation is not supported by your browser.");
    }
  }, []);

  const handleSendOtp = () => {
    setMobileErr("");
    if (!mobile || mobile.replace(/\D/g, "").length !== 10) {
      setMobileErr("Please enter a valid 10-digit mobile number");
      return;
    }

    fetch(`${localApi}/user/sendotp?mobile=+${mobile}&type=client&webappid=1`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((resp) => {
        if (resp.message === "Enter Registerd Mobile number") {
          setMobileErr("Please enter a registered mobile number");
        } else if (resp.error === "false") {
          setExpectedOtp(resp.message);
          setOtpScreen(true);
        }
      })
      .catch(console.error);
  };

  const handleLogin = () => {
    setOtpNumberErr("");
    if (otpNumber.length !== 6) {
      setOtpNumberErr("Invalid OTP");
      return;
    }

    fetch(
      `${localApi}/user/login?otp=${otpNumber}&mobile=+${mobile}&type=client`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    )
      .then((res) => res.json())
      .then((resp) => {
        if (resp.apiResponse?.error !== "false") {
          setOtpNumberErr("OTP verification failed");
        } else {
          sessionStorage.setItem("sessionData", JSON.stringify(resp.user));
          setLoginModal(false);
          history.push("/product-list");
        }
      })
      .catch(console.error);
  };

  const handleCallMe = () => {
    fetch(`${localApi}/user/callMe?mobile=+${mobile}&type=client&webappid=1`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((msg) => {
        if (msg === "Thank You for Visiting! We will reach back to you soon.") {
          alert(msg);
        }
      })
      .catch(console.error);
  };

  return (
    <div>
      <Helmet>
        {/* <title>Insha Bangles</title>
        <meta name="description" content="Best Manufacture Comapnay" />
        <meta
          name="keywords"
          content="We are one of the top manufacturers and retailers in Maharastra & Karnataka"
        /> */}
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="INSHA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>
      <InshaHeader
        brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" textAlign="center" />}
        fixed
        // color="transparent"
        color="dark"
        // changeColorOnScroll={{ height: 400, color: "dark" }}
      />

      <Parallax
        image={require("assets/img/Landing.jpg").default}
        className={classes.parallax}
      >
        <div className={classes.container}>
          {!activeSession && (
            <GridItem xs={12} sm={6} md={6}>
              <Dialog
                classes={{
                  root: js.modalRoot,
                  paper: js.modal + " " + js.modalLogin,
                }}
                open={loginModal}
                TransitionComponent={Transition}
                keepMounted
              >
                <Card plain className={js.modalLoginCard}>
                  <DialogTitle disableTypography className={js.modalHeader}>
                    <CardHeader
                      plain
                      color="rose"
                      className={js.textCenter + " " + js.cardLoginHeader}
                    >
                      <h5 className={js.cardTitleWhite}>Log in</h5>
                    </CardHeader>
                  </DialogTitle>
                  <DialogContent className={js.modalBody}>
                    {!otpScreen ? (
                      <form>
                        <CardBody className={js.cardLoginBody}>
                          <PhoneInput
                            country={"in"}
                            value={mobile}
                            inputStyle={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #000",
                              borderRadius: "0",
                            }}
                            onChange={(value) => setMobile(value)}
                          />
                          <span style={{ color: "red" }}>{mobileErr}</span>
                        </CardBody>
                        <DialogActions className={js.justifyContentCenter}>
                          <Button
                            color="rose"
                            simple
                            size="lg"
                            onClick={handleSendOtp}
                          >
                            Log in with OTP
                          </Button>
                          <Button
                            color="rose"
                            simple
                            size="lg"
                            href="/insha-register"
                          >
                            Create New Account
                          </Button>
                        </DialogActions>
                      </form>
                    ) : (
                      <form>
                        <p className={js.textCenter}>
                          6-digit OTP has been sent to your number
                        </p>
                        <CardBody className={js.cardLoginBody}>
                          <CustomInput
                            id="otpNumber"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "otpNumber",
                              value: otpNumber,
                              onChange: (e) => setOtpNumber(e.target.value),
                              placeholder: "Enter OTP here",
                              type: "text",
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Icon className={classes.inputIconsColor}>
                                    lock_outline
                                  </Icon>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <span style={{ color: "red" }}>{otpNumberErr}</span>
                        </CardBody>
                        <div className={classes.textCenter}>
                          <Button
                            simple
                            color="rose"
                            size="lg"
                            onClick={handleLogin}
                          >
                            Log in
                          </Button>
                          <Button
                            simple
                            color="rose"
                            size="lg"
                            onClick={handleCallMe}
                          >
                            <FiPhoneCall /> Call Me
                          </Button>
                        </div>
                      </form>
                    )}
                  </DialogContent>
                </Card>
              </Dialog>
            </GridItem>
          )}

          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1>INSHA BANGLES</h1>
                <h3 className={classes.title}>
                  We have everything in Fashion and Style, Ready for<br />every
                  occasion and our designs never go out of Fashion.
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <InshaSection />
      </div>

      <InshaContact />
      <Footer />
    </div>
  );
}
